import { render, staticRenderFns } from "./userTemplate.vue?vue&type=template&id=96289118&scoped=true"
import script from "./userTemplate.vue?vue&type=script&lang=js"
export * from "./userTemplate.vue?vue&type=script&lang=js"
import style0 from "./userTemplate.vue?vue&type=style&index=0&id=96289118&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96289118",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('96289118')) {
      api.createRecord('96289118', component.options)
    } else {
      api.reload('96289118', component.options)
    }
    module.hot.accept("./userTemplate.vue?vue&type=template&id=96289118&scoped=true", function () {
      api.rerender('96289118', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/salesControl/controlPinForm/userTemplate.vue"
export default component.exports